var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 54.59 39.57"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.57 39.57a1 1 0 01-.78-1.63l13.72-17.16H1a1 1 0 010-2h50.51L37.79 1.62A1 1 0 1139.35.38l15 18.77a1 1 0 010 1.26l-15 18.78a1 1 0 01-.78.38z",
    "data-name": "Layer 1"
  }))));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA1NC41OSAzOS41NyI+PGcgaWQ9IkxheWVyXzIiIGRhdGEtbmFtZT0iTGF5ZXIgMiI+PGcgaWQ9IkxheWVyXzEtMiIgZGF0YS1uYW1lPSJMYXllciAxIj48ZyBpZD0iYXJyb3ctbGVmdCI+PHBhdGggZD0iTTM4LjU3LDM5LjU3YTEsMSwwLDAsMS0uNzgtMS42M0w1MS41MSwyMC43OEgxYTEsMSwwLDAsMSwwLTJINTEuNTFMMzcuNzksMS42MkExLDEsMCwxLDEsMzkuMzUuMzhsMTUsMTguNzdhMSwxLDAsMCwxLDAsMS4yNmwtMTUsMTguNzhBMSwxLDAsMCwxLDM4LjU3LDM5LjU3WiIvPjwvZz48L2c+PC9nPjwvc3ZnPg==";
export { SvgArrowRight as ReactComponent };